import request from '@/utils/request'

export function modifyClient(data) {
  return request.post('/wxfwh/client-modify', data)
}

export function getClientDetail(data) {
  return request.post('/wxfwh/client-detail', data)
}

export function getClientList(data) {
  return request.post('/wxfwh/client-list', data)
}

export function preBindClient(data) {
  return request.post('/wxfwh/pre-bind-client', data)
}

export function bindClient(data) {
  return request.post('/wxfwh/bind-client', data)
}
export function getWorkbenchClientDetail(data) {
  return request.post('/api/service/workbench ', data)
}



// WEBPACK FOOTER //
// ./src/api/client.js